import { render, staticRenderFns } from "./ProjectsTabs.vue?vue&type=template&id=da74c6ee&scoped=true"
import script from "./ProjectsTabs.vue?vue&type=script&lang=js"
export * from "./ProjectsTabs.vue?vue&type=script&lang=js"
import style0 from "./ProjectsTabs.vue?vue&type=style&index=0&id=da74c6ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da74c6ee",
  null
  
)

export default component.exports